import React, { Suspense } from 'react';

import { Outlet } from 'react-router-dom';
import { observer } from 'mobx-react-lite';

import AgentPanel from '../AgentPanel';
import AppTopBar from './AppTopBar';
import ErrorBoundary from '../ErrorBoundary';
import RouteLoading from '../RouteLoading';
import WorkflowStepper from './WorkflowStepper';
import WorkflowToolbar from './WorkflowToolbar';
import { WorkflowChromeProvider } from './WorkflowChromeContext';
import { PeriodRunProvider } from './PeriodRun/PeriodRunContext';
import RunBanner from './PeriodRun/RunBanner';
import RunOverlay from './PeriodRun/RunOverlay';
import RunSheets from './PeriodRun/RunSheets';
import RunSummary from './PeriodRun/RunSummary';

import { Container, Content, Wrapper } from './style';

const Layout = () => {
  return (
    <WorkflowChromeProvider>
      {/* Above the outlet, because the run it holds walks from one stage page to the next and must
          not be unmounted on the way. */}
      <PeriodRunProvider>
        <Container>
          <Wrapper>
            <AppTopBar />
            <RunBanner />
            <WorkflowStepper />
            <WorkflowToolbar />
            <Content open={false}>
              <ErrorBoundary componentName="Route">
                <Suspense fallback={<RouteLoading />}>
                  <Outlet />
                </Suspense>
              </ErrorBoundary>
            </Content>
            <RunOverlay />
            <RunSheets />
            <RunSummary />
            <div className="clearer"></div>
          </Wrapper>
          <AgentPanel />
        </Container>
      </PeriodRunProvider>
    </WorkflowChromeProvider>
  );
};

export default observer(Layout);
